import React from 'react';

import { connect } from 'react-redux';
import compose from 'recompose/compose';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Card from 'components/Card/Card.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

import Style from 'assets/jss/material-dashboard-pro-react/modalStyle.jsx';

// @material-ui/icons
import Close from '@material-ui/icons/Close';

// core components
import Button from 'components/CustomButtons/Button.jsx';
import Transition from 'components/Transition';
import { closeSolicitationDialog } from '../../store/actions/navigationActions';

export function SolicitationDialog(props) {
    const { classes, open, onCancel, onContinue, warningText, doAction } = props;
    return (
        <Dialog
            classes={{
                root: classes.modalRoot,
                paper: classes.modal + ' ' + classes.modalSmall,
            }}
            id="solicitation"
            open={open}
            TransitionComponent={Transition}
            keepMounted
            aria-labelledby="solicitationDialog-modal-title"
            aria-describedby="solicitationDialog-modal-description"
        >
            <Card
                style={{
                    margin: '0px 0% 0px 5%',
                    width: '90%',
                    backgroundColor: '#F7F3F0',
                    borderRadius: '10px',
                }}
            >
                <DialogTitle
                    id="solicitationDialog-modal-title"
                    disableTypography
                    className={classes.modalHeader}
                >
                    <Button
                        simple
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        onClick={onCancel}
                    >
                        {' '}
                        <Close className={classes.modalClose} />
                    </Button>
                    <h2 className={classes.modalTitle}>
                        <span style={{ color: 'black' }}>
                            <center>Sharing Advice</center>
                        </span>
                    </h2>
                </DialogTitle>
                <DialogContent
                    id="solicitationDialog-modal-description"
                    className={classes.modalBody}
                >
                    <div style={{ marginLeft: '10px', marginRight: '10px', marginBottom: '30px', marginTop: '0px' }}>
                    {warningText}
                    </div>
                    <div
                        style={{
                            textAlign: 'center',
                        }}
                    >
                        <Button
                            className={classes.ltrButtonWhite}
                            style={{ backgroundColor: '#FC6047', width: '90%' }}
                            key="cancel"
                            aria-label="Cancel"
                            onClick={()=>doAction(onCancel)}
                        >
                            <b>CANCEL</b>
                        </Button>
                        <Button
                            className={classes.ltrButtonWhite}
                            style={{ backgroundColor: '#FC6047', width: '90%' }}
                            key="continue"
                            aria-label="Continue"
                            onClick={()=>doAction(onContinue)}
                        >
                            <b>CONTINUE</b>
                        </Button>                        
                    </div>
                </DialogContent>
            </Card>
        </Dialog>
    );
}

const mapStateToProps = (state) => {
    return { 
        warningText: state.navigation.warningText,
        onContinue: state.navigation.onContinue,
        onCancel: state.navigation.onCancel,
        open: state.navigation.solicitationDialogOpen
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      doAction: action => action ? dispatch(action).then(dispatch(closeSolicitationDialog())) : dispatch(closeSolicitationDialog())
    }
  }
  
  export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(Style)
  )(SolicitationDialog);
  